<template>
    <div class="account">
        <a-page-header
        style="border: 1px solid rgb(235, 237, 240);background:#fff;padding:16px 32px"
        :breadcrumb="{ props: { routes } }"
        />
        <div class="account-deatil" style="background:#fff;">
            <a-card>
                <div class="search">
                    <a-button type="primary" style="margin-left:14px" @click="addmodal">添加角色</a-button>
                </div>

                  <a-table
                    :columns="columns"
                    :pagination="pagination"
                    :loading="loading"
                    @change="handleTableChange"
                    :data-source="data"
                >
                    <span slot="action" slot-scope="text, record">
                        <!-- <a-button type="primary" :size="size"  @click="qxtmodal(index,$event)" :id="record.id"><a-icon type="edit" />权限分配</a-button> -->
                        <a-button type="primary" :size="size"  @click="editmodal(index,$event)" :id="record.id"><a-icon type="edit" />编辑</a-button>
                        <a-button type="danger" :size="size" @click="deleterole(index,$event)" :id="record.id"><a-icon type="delete" />删除</a-button>
                    </span>
                </a-table>
            </a-card>
        </div>


        <!-- 添加 -->
        <a-modal
        class="pwdmodal"
        title="添加角色"
        cancelText="取消"
        okText="确定"
        width="600px"
        :visible="rolemodal"
        :confirm-loading="confirmLoading"
        @ok="addrole"
        @cancel="handleCancel"
        >
            <a-row>
                <a-col :span="5">
                    <label class="required-icon">角色名称：</label>
                </a-col>
                <a-col :span="16">
                   <a-input  v-model="name" placeholder="请输入角色名称"></a-input>
                </a-col>
            </a-row>
            <a-row style="overflow-y:scroll">
                <a-col :span="5">
                    <label>角色权限：</label>
                </a-col>
                  <a-col :span="16">
                    <a-tree
                        v-if="treeData.length"
                        class="rolechoose"
                        v-model="checkedKeys"
                        checkable
                        defaultExpandAll
                        :tree-data="treeData"
                        @check="onCheck"
                        :replace-fields="replaceFields"
                    />
                </a-col>
            </a-row>
        </a-modal>

        <!-- 编辑 -->
        <a-modal
        class="pwdmodal"
        title="编辑角色"
        cancelText="取消"
        okText="确定"
        width="600px"
        :visible="editrolemodal"
        :confirm-loading="confirmLoading"
        @ok="editrole"
        @cancel="handleCancel"
        >
            <a-row>
                <a-col :span="5">
                    <label class="required-icon">角色名称：</label>
                </a-col>
                <a-col :span="16">
                   <a-input  v-model="roledetail.name" placeholder="请输入角色名称"></a-input>
                </a-col>
            </a-row>
            <a-row style="overflow-y:scroll">
                <a-col :span="5">
                    <label>角色权限：</label>
                </a-col>
                  <a-col :span="16">
                    <a-tree
                        v-if="roledetail"
                        class="rolechoose"
                        v-model="roledetail.menu_ids"
                        checkable
                        defaultExpandAll
                        :tree-data="treeData"
                        @check="onCheck"
                        :replace-fields="replaceFields"
                    />
                </a-col>
            </a-row>
        </a-modal>
    </div>
</template>
    
<script>
import { Modal } from 'ant-design-vue';
const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: '角色名称',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: '添加时间',
    dataIndex: 'create_time',
    key: 'create_time',
  },
  {
    title: '操作',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' },
  },
];

export default {
    data(){
        return{
            routes: [
                {path:'home/main',breadcrumbName: '首页'},
                {breadcrumbName: '角色管理'}
            ],
            data:"",
            columns,
            pagination:{},
            loading:false,
            id:"",
            rolemodal:false,
            confirmLoading:false,
            name:"",
            editrolemodal:false,
            size:'small',
            qxlist:"",

            // expandedKeys: ['0-0-0', '0-0-1'],
            autoExpandParent: true,
            checkedKeys: [],
            selectedKeys: [],
            treeData:"",
            replaceFields:{
                children: 'child',
                title: 'name',
                key:'id'
            },
            defaultqx:"",
            roledetail:"",
            menuids:"",
            qxid:[],
            currentpagination:"",
            // checkedKeys:[]
        }
    },
    mounted(){
        // this.$axios.get('/api/getrolelist',{
        //     headers: {
        //         "appid": this.appSet.appid,
        //         "appkey": this.appSet.appkey,
        //         "token":localStorage.getItem('token'),
        //     }
        // }).then((res)=>{
        //     if(res.data.code==200){
        //         this.data=res.data.data.lists
        //     }else if(res.data.code==300){
        //         this.$router.push({path: '/'})
        //     }else if(res.data.code==401){

        //     }else{

        //     }
        // })

        this.fetch()

        this.$axios.get('/api/getALLMenu',{
            headers: {
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            }
        }).then((res)=>{
            if(res.data.code==200){
                // this.qxlist=res.data.data.lists
                var data=res.data.data
                // data=JSON.parse(JSON.stringify(data).replace(/child/g, 'children'));
                // data=JSON.parse(JSON.stringify(data).replace(/name/g, 'title'));
                // data=JSON.parse(JSON.stringify(data).replace(/id/g, 'value'));
                this.treeData=data
            }else if(res.data.code==300){
                this.$router.push({path: '/'})
            }else if(res.data.code==401){

            }else{

            }
        })
    },
    methods:{
        handleTableChange(pagination) {
            console.log(pagination);
            const pager = { ...this.pagination };
            pager.current = pagination.current;
            this.pagination = pager;

            this.currentpagination=pagination

            this.fetch({
                limits: pagination.pageSize,
                page: pagination.current,
            });
        },

        fetch(params = {}) {
            this.loading = true;
            this.$axios.get('/api/getrolelist',{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
                params:{
                    limits: 10,
                    ...params,
                }
            }).then((res)=>{
                if(res.data.code==200){
                    const pagination = { ...this.pagination };
                    pagination.total = res.data.data.count;
                    this.data=res.data.data.lists
                    this.loading = false;
                    this.pagination = pagination;
                    // this.data=res.data.data.lists
                    // this.loading = false;
                    // this.pagination = pagination;
                }else if(res.data.code==300){
                    this.$router.push({path: '/'})
                }else if(res.data.code==401){
                    this.$message.warning(res.data.msg); 
                }else{
                    this.$message.warning(res.data.msg); 
                }
            })

        },

        addmodal(){
            this.rolemodal=true
        },
        deleterole(index,event){
            var editid=event.currentTarget.id
            var params=new URLSearchParams()
            params.append('id',editid)
            Modal.confirm({
                title: '提示',
                content: '您确定删除此角色吗?',
                okText: '确定',
                okType: 'danger',
                cancelText: '取消',
                onOk:()=> {
                    this.$axios.post('/api/delRole',params,{
                        headers: {
                            "appid": this.appSet.appid,
                            "appkey": this.appSet.appkey,
                            "token":localStorage.getItem('token'),
                        }
                    }).then((res)=>{
                        console.log("res="+res.data.data)
                        if(res.data.code==40014){
                            this.$message.warning(res.data.msg); 
                        }else if(res.data.code==200){
                            this.$message.success('删除成功');
                            this.fetch({
                                limits: this.currentpagination.pageSize,
                                page: this.currentpagination.current,
                            });
                        }else{
                            this.$message.warning(res.data.msg); 
                        }
                        // }else if(res.data.code==300){
                        //     this.$router.push({path: '/'})
                        // }else if(res.data.code==401){

                        // }else{

                        // }
                    })
                },
                onCancel() {

                },
            });
        },
        onCheck(checkedKeys, info) {
            this.checkedKeys=checkedKeys
            // console.log('onCheck', this.menuids);

        },
        editrole(){
            var params=new URLSearchParams()
            var checkedKeys=this.checkedKeys
            for(var i in checkedKeys){
                if(this.menuids==""){
                    this.menuids=checkedKeys[i]
                }else{
                    this.menuids= this.menuids+','+checkedKeys[i]
                }
                
            }
            params('id',this.id)
            params.append('name',this.roledetail.name)
            params.append('menuids',this.roledetail.menu_ids)
            this.$axios.post('/api/editrole',params,{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.$message.success('编辑成功');
                    this.rolemodal=false
                    this.fetch({
                        limits: this.currentpagination.pageSize,
                        page: this.currentpagination.current,
                    });

                    
                }else if(res.data.code==300){
                    this.$router.push({path: '/'})
                }else if(res.data.code==401){
                    this.$message.warning(res.data.msg); 
                }else{
                    this.$message.warning(res.data.msg); 
                }
            })
        },
        handleCancel(){
            this.rolemodal=false
            this.editrolemodal=false
        },

        // 编辑角色
        editmodal(index,event){

            var editid=event.currentTarget.id
            this.id=editid
            this.$axios.get('/api/getroledetail',{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
                params:{
                    id:editid
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.editrolemodal=true
                    this.roledetail=res.data.data
                    this.qxid=this.qxid.splice(0,this.qxid.length);
                    for(var i in this.roledetail.menu_ids){
                        this.qxid.push(parseInt(this.roledetail.menu_ids[i]))
                    }
                    console.log("qxid"+this.qxid)
                    this.roledetail.menu_ids=this.qxid
                }else if(res.data.code==300){
                    this.$router.push({path: '/'})
                }else if(res.data.code==401){
                    this.$message.warning(res.data.msg); 
                }else{
                    this.$message.warning(res.data.msg); 
                }
            })
        },
        // 权限设置
        // delmodal(index,event){
        //     var editid=event.currentTarget.id
        //     var params=new URLSearchParams()
        //     params.append('id',editid)
        //     this.$confirm({
        //         title: '提示',
        //         content: '您确定删除此角色吗?',
        //         okText: '确定',
        //         okType: 'danger',
        //         cancelText: '取消',
        //         onOk() {
        //             this.$axios.post('/api/delfolwtype',params,{

        //             })
        //         },
        //         onCancel() {

        //         },
        //     });
        // },
        // 添加角色
        addrole(){
            var params=new URLSearchParams()
            var checkedKeys=this.checkedKeys
            for(var i in checkedKeys){
                if(this.menuids==""){
                    this.menuids=checkedKeys[i]
                }else{
                    this.menuids= this.menuids+','+checkedKeys[i]
                }
                
            }
            params.append('name',this.name)
            params.append('menuids',this.menuids)
            this.$axios.post('/api/addrole',params,{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.rolemodal=false
                    this.fetch()
                    
                }else if(res.data.code==300){
                    this.$router.push({path: '/'})
                }else if(res.data.code==401){
                    this.$message.warning(res.data.msg); 
                }else{
                    this.$message.warning(res.data.msg); 
                }
            })
        }
        
    }
}
</script>



// WEBPACK FOOTER //
// src/components/role/index.vue